import {
  ApplicationFlag,
  FamilyApplicationResp,
  FamilyAttestation,
  Student,
} from '@/apis/family_application/requests'
import { attestationRoute } from '@/routing/family_application_routes'
import { AppRoutePaths } from '@/routing/route_paths'
import { FamilyApplicationRoutes } from './routing/family-application.routing.types'

export const APPLICATION_STATUS = {
  Invited: 1,
  In_Progress: 2,
  Incomplete: 3,
  Pending: 4,
  Manual_Review: 5,
  In_Eligible: 6,
  Complete: 7,
  Awarded: 8,
  Appeal: 9,
  Funded: 10,
  WaitListed: 11,
} as const

export const ATTESTATION_STATUS = {
  CONFIRMED: 1,
  NOT_CONFIRMED: 0,
} as const

export function getSelectedStudent(
  selectedStudentId: number | null,
  students: Student[] | null
) {
  return students?.find((student) => student.id === selectedStudentId)
}

export function getProgramYear(
  program_start_date?: string,
  program_end_date?: string
) {
  if (program_start_date && program_end_date) {
    const getYear = (dateString: string) => {
      const date = new Date(dateString)
      return date.getFullYear()
    }
    return getYear(program_start_date) + '-' + getYear(program_end_date)
  }
  return ''
}


export function getAttestationRoute(
  attestations: FamilyAttestation[] | undefined
): FamilyApplicationRoutes {
  if (!attestations || attestations.length === 0) {
    return AppRoutePaths.family_application.student_details.success_verification
  }

  return attestationRoute(
    attestations[0].id.toString()
  ) as FamilyApplicationRoutes

  // Temporarily commented out logic that checks what questions have been answered
  // And navigates to the next question that's still unanswered

  /*   const lastUnacceptedIndex = attestations.findIndex((attestation) => {
    return attestation.status === 0
  })

  // No unaccepted attestations found
  if (lastUnacceptedIndex === -1) {
    return AppRoutePaths.family_application.review_application
  }

  // Handle in-progress case
  return attestationRoute(attestations[lastUnacceptedIndex].appeal_details.toString()) */
}

export function didNotCompleteIdentityVerification(flags: ApplicationFlag[]) {
  return flags.map((flag) => {
    return (
      flag.flag_code === 'identity' ||
      flag.flag_code === 'clearme_data_inaccurate'
    )
  })
}

export function hasRenewalStudents(application: FamilyApplicationResp) {
  return application.students.some(
    (student) => student.inception_status === 'Renewal Student'
  )
}

export function getStudentDetailsStartRoute(
  application: FamilyApplicationResp
) {
  const hasRenewals = hasRenewalStudents(application)

  return hasRenewals
    ? AppRoutePaths.family_application.student_details.additional_student
    : AppRoutePaths.family_application.student_details.index
}

export function getEligibleAndFundedStudents(students: Student[]) {
    return students.filter((student) => {
      return student.application_status === "Funded" 
    })
}